import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStateAddAdditionalTaxes extends Layout {
    sourceStatetaxAdditional: DataSource;
    textboxDeductCodeId: Textbox;
    textboxEmployeeAddtlTable: Textbox;
    textboxEmployeeAuxiliary: Textbox;
    textboxEmployeeMiscellaneous: Textbox;
    textboxEmployerAddtlTable: Textbox;
    textboxEmployerAuxiliary: Textbox;
    textboxEmployerMiscellaneous: Textbox;
    textboxExpenseGlid: Textbox;
    textboxJobClassCodeId: Textbox;
    textboxLiabilityGlid: Textbox;
    textboxTaxType: Textbox;
}
